export default __webpack_public_path__ + "static/media/mail-green.658105db.svg";